/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 10.1.2
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FoursquareAddendum } from "./FoursquareAddendum";
import {
  FoursquareAddendumFromJSON,
  FoursquareAddendumFromJSONTyped,
  FoursquareAddendumToJSON,
  FoursquareAddendumToJSONTyped,
} from "./FoursquareAddendum";
import type { WhosOnFirstConcordances } from "./WhosOnFirstConcordances";
import {
  WhosOnFirstConcordancesFromJSON,
  WhosOnFirstConcordancesFromJSONTyped,
  WhosOnFirstConcordancesToJSON,
  WhosOnFirstConcordancesToJSONTyped,
} from "./WhosOnFirstConcordances";
import type { OpenStreetMapAddendum } from "./OpenStreetMapAddendum";
import {
  OpenStreetMapAddendumFromJSON,
  OpenStreetMapAddendumFromJSONTyped,
  OpenStreetMapAddendumToJSON,
  OpenStreetMapAddendumToJSONTyped,
} from "./OpenStreetMapAddendum";
import type { GeonamesAddendum } from "./GeonamesAddendum";
import {
  GeonamesAddendumFromJSON,
  GeonamesAddendumFromJSONTyped,
  GeonamesAddendumToJSON,
  GeonamesAddendumToJSONTyped,
} from "./GeonamesAddendum";

/**
 * Miscellaneous data that doesn't quite fit anywhere else in the record.
 * @export
 * @interface AddendumV2
 */
export interface AddendumV2 {
  /**
   *
   * @type {FoursquareAddendum}
   * @memberof AddendumV2
   */
  foursquare?: FoursquareAddendum | null;
  /**
   *
   * @type {GeonamesAddendum}
   * @memberof AddendumV2
   */
  geonames?: GeonamesAddendum | null;
  /**
   *
   * @type {OpenStreetMapAddendum}
   * @memberof AddendumV2
   */
  osm?: OpenStreetMapAddendum | null;
  /**
   *
   * @type {WhosOnFirstConcordances}
   * @memberof AddendumV2
   */
  whosonfirstConcordances?: WhosOnFirstConcordances | null;
}

/**
 * Check if a given object implements the AddendumV2 interface.
 */
export function instanceOfAddendumV2(value: object): value is AddendumV2 {
  return true;
}

export function AddendumV2FromJSON(json: any): AddendumV2 {
  return AddendumV2FromJSONTyped(json, false);
}

export function AddendumV2FromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AddendumV2 {
  if (json == null) {
    return json;
  }
  return {
    foursquare:
      json["foursquare"] == null
        ? undefined
        : FoursquareAddendumFromJSON(json["foursquare"]),
    geonames:
      json["geonames"] == null
        ? undefined
        : GeonamesAddendumFromJSON(json["geonames"]),
    osm:
      json["osm"] == null
        ? undefined
        : OpenStreetMapAddendumFromJSON(json["osm"]),
    whosonfirstConcordances:
      json["whosonfirst_concordances"] == null
        ? undefined
        : WhosOnFirstConcordancesFromJSON(json["whosonfirst_concordances"]),
  };
}

export function AddendumV2ToJSON(json: any): AddendumV2 {
  return AddendumV2ToJSONTyped(json, false);
}

export function AddendumV2ToJSONTyped(
  value?: AddendumV2 | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    foursquare: FoursquareAddendumToJSON(value["foursquare"]),
    geonames: GeonamesAddendumToJSON(value["geonames"]),
    osm: OpenStreetMapAddendumToJSON(value["osm"]),
    whosonfirst_concordances: WhosOnFirstConcordancesToJSON(
      value["whosonfirstConcordances"],
    ),
  };
}
